import { render, staticRenderFns } from "./NodeAllocationPoolCard.vue?vue&type=template&id=548c5e01&scoped=true&"
import script from "./NodeAllocationPoolCard.vue?vue&type=script&lang=js&"
export * from "./NodeAllocationPoolCard.vue?vue&type=script&lang=js&"
import style0 from "./NodeAllocationPoolCard.vue?vue&type=style&index=0&id=548c5e01&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548c5e01",
  null
  
)

export default component.exports